import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MapForAllComponent } from './map/map-for-all.component';
import { PortalTicketFormComponent } from './ticket-list/portal-ticket-form/portal-ticket-form.component';
import { CommonComponentsService } from './common-components.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectFilterModule } from '@devlukaszmichalak/mat-select-filter';
import { NgxGalleryModule } from 'ngx-gallery-15';
import { NgxMaskModule } from 'ngx-mask';
import { HelpPageComponent } from './help-page/help-page.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [
    MapForAllComponent,
    PortalTicketFormComponent,
    HelpPageComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PdfViewerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    CommonModule,
    MatPaginatorModule,
    MatSortModule,
    MatBadgeModule,
    MatSelectFilterModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgxGalleryModule,
    NgxMaskModule.forRoot(),
    MatOptionModule,
    MatSelectModule
  ],
  providers: [CommonComponentsService]
})
export class CommonComponentsModule { }
